import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Plano} from "../../models/plano";
import {FormControl, FormGroup} from "@angular/forms";
import {Estado} from "../../models/estado";
import {Municipio} from "../../models/municipio";
import {SituacaoPlano} from "../../models/situacao-plano";
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../../core/services/message.service";
import {PlanoService} from "../../services/plano.service";
import {EstadoService} from "../../services/estado.service";
import {MunicipioService} from "../../services/municipio.service";
import {SituacaoPlanoService} from "../../services/situacao-plano.service";
import {Login} from "../../models/login";
import {Perfil} from "../../models/perfil";
import {Router} from "@angular/router";
import {LoginService} from "../../services/login.service";
import {MatSort, MatTableDataSource, Sort, MatPaginator} from "@angular/material";

@Component({
    selector: 'app-consultar-minuta',
    templateUrl: './consultar-minuta.component.html',
    styleUrls: ['./consultar-minuta.component.scss']
})
export class ConsultarMinutaComponent implements OnInit, AfterViewInit {

    public planos: Array<Plano> = [];
    public data_source: MatTableDataSource<any>;
    public carregando: boolean = false;
    public pesquisa_realizada: boolean = false;
    public form: FormGroup;
    public estados: Array<Estado>;
    public municipios: Array<Municipio>;
    public situacoes: Array<SituacaoPlano>;

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(private loadingService: NgxSpinnerService,
                private messageService: MessageService,
                private planoService: PlanoService,
                private estadoService: EstadoService,
                private municipioService: MunicipioService,
                private situacaoPlanoService: SituacaoPlanoService,
                private router: Router, private loginService: LoginService) {

    }

    ngOnInit() {
        this.data_source = new MatTableDataSource(this.planos);
        let login: Login = this.loginService.getAuth();
        let url: string;
        if (login) {
            if (login.perfil != Perfil.ADMINISTRADOR) {
                url = "/plano";
                this.router.navigateByUrl(url);
            }
        } else {
            url = "/login";
            this.router.navigateByUrl(url);
        }
        this.form = new FormGroup({
            uf: new FormControl(null),
            cod_situacao: new FormControl(null),
            cod_municipio: new FormControl(null),
        });
        this.carregarSituacoes();
        this.carregarEstados();
    }

    ngAfterViewInit(): void {
        this.data_source.sort = this.sort;
        this.data_source.paginator = this.paginator;
        this.data_source.sortingDataAccessor = (data, header) => data[header];
    }

    sortData(sort: Sort): void {
        const data = this.data_source.data.slice();
        if (!sort.active || sort.direction === '') {
            this.data_source.data = data;
        }
        this.data_source.data = data.sort((a, b) => {
            const is_asc = sort.direction === 'asc';
            switch (sort.active) {
                case 'cidade':
                    return this.compare(a.municipio.txt_nome_municipio, b.municipio.txt_nome_municipio, is_asc);
                case 'data_atualizacao':
                    return this.compare(a.dte_atualizacao, b.dte_atualizacao, is_asc);
                case 'gestor':
                    return this.compare(a.usuario.txt_nome, b.usuario.txt_nome, is_asc);
                default:
                    return 0;
            }
        });
    }

    carregarSituacoes(): void {
        this.loadingService.show();
        this.situacoes = [];
        this.situacaoPlanoService.listAll().subscribe((situacoes: Array<SituacaoPlano>) => {
            this.situacoes = situacoes;
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
    }

    compare(a: number | string, b: number | string, is_asc: boolean): number {
        return (a < b ? -1 : 1) * (is_asc ? 1 : -1);
    }

    carregarPlanos(uf: string = null, municipio: number = null, situacao: string = null): void {
        this.planos = [];
        this.data_source.data = this.planos;
        this.pesquisa_realizada = false;
        this.loadingService.show();
        this.carregando = true;
        this.planoService.listAll(uf, municipio, null, situacao, true).subscribe((planos: Array<Plano>) => {
            this.planos = planos;
            this.data_source.data = this.planos;
            this.data_source.paginator = this.paginator;
            this.loadingService.hide();
            this.carregando = false;
            this.pesquisa_realizada = true;
        }, () => {
            this.loadingService.hide();
            this.carregando = false;
            this.pesquisa_realizada = true;
        });
    }

    carregarEstados(): void {
        this.loadingService.show();
        this.estados = [];
        this.estadoService.listAll().subscribe((estados: Array<Estado>) => {
            this.estados = estados;
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
        this.form.patchValue({
            cod_municipio: null,
        });
    }

    carregarMunicipios(uf: string): void {
        this.municipios = [];
        if (uf) {
            this.loadingService.show();
            this.municipioService.listAll(uf).subscribe((municipios: Array<Municipio>) => {
                this.municipios = municipios;
                this.loadingService.hide();
            }, () => {
                this.loadingService.hide();
            });
        }
    }

    exportarPdf(plano: number): void {
        this.planoService.exportPdf(plano);
    }

    print(): void {
        window.print();
    }

}
